import { PhraseBankSection } from '..';

export const slogan: PhraseBankSection = [
  'The only trusted name in drunk weather',
  `The least reliable name in weather`,
  `All the news that’s fit to pint`,
  `Trust the bow tie one on`,
];
